// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3AbgN","large":"styles_large__M5yhd"};